/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ObservableModel } from '@typescript-kit/core';
import { Company } from '@teamworks/global';
import { Employee } from '@teamworks/global';
import { TimeRecord } from '@teamworks/global';

export interface TimeClockEmployeeViewData {
  company?: Company;
  employee?: Employee;
  timeRecordList?: TimeRecord[];
}

export class TimeClockEmployeeViewFieldKey {
  static readonly COMPANY = 'company';
  static readonly EMPLOYEE = 'employee';
  static readonly TIME_RECORD_LIST = 'timeRecordList';
}

export class TimeClockEmployeeViewModel extends ObservableModel {
  static readonly KEYS = Object.keys(TimeClockEmployeeViewFieldKey).map((key) => TimeClockEmployeeViewFieldKey[key]);

  constructor(data?: TimeClockEmployeeViewData) {
    super(data, TimeClockEmployeeViewModel.KEYS);
  }

  get company(): Company {
    return this.get(TimeClockEmployeeViewFieldKey.COMPANY);
  }

  set company(value: Company) {
    this.set(TimeClockEmployeeViewFieldKey.COMPANY, value);
  }

  get employee(): Employee {
    return this.get(TimeClockEmployeeViewFieldKey.EMPLOYEE);
  }

  set employee(value: Employee) {
    this.set(TimeClockEmployeeViewFieldKey.EMPLOYEE, value);
  }

  get timeRecordList(): TimeRecord[] {
    return this.get(TimeClockEmployeeViewFieldKey.TIME_RECORD_LIST);
  }

  set timeRecordList(value: TimeRecord[]) {
    this.set(TimeClockEmployeeViewFieldKey.TIME_RECORD_LIST, value);
  }

}
